import { h } from 'preact';
const App = () => {
	return <div></div>

}

export default App;
